import axios from "axios";

import { AppConfig } from "../config/app.config";

export const api = axios.create({
    baseURL: AppConfig.app.apiUrl,
    headers: {
        'Content-type': 'application/json'
    },
});